import RadioGroup from '../../old_components/baseComponents/RadioGroup';
import MapContentHolder from '../MapContentHolder'
import {useSelector} from 'react-redux';
import useStyles from './useStyles'
import {memo, useEffect, useState} from "react";
import {GeozoneIntersections} from "../GeozoneIntersections/GeozoneIntersections";
import SaveStatus from "../../UIComponents/SaveStatus";
import {getCriteria} from '../../shared/helpers/getCriteria';

const mapStateToProps = (state) => {
  const {
    geozone: {
      geozoneArr = [],
      geozoneSettingsArr = [],
    },
    ui: {
      geoObjCriteria,
      rangeStartDate,
      rangeEndDate,
      dateRangeCriteria,
      selectedGeoObjArray
    } = {},
    api: {
      getDataGeozoneIntersections
    } = {},
    service: {
      Api: {
        getGeozoneIntersections
      } = {}
    } = {}
  } = state;
  return {
    getDataGeozoneIntersections,
    geoObjCriteria,
    rangeStartDate,
    rangeEndDate,
    geozoneArr,
    geozoneSettingsArr,
    getGeozoneIntersections,
    selectedGeoObjArray,
    dateRangeCriteria,
  }
}

function MapLayout(props) {
  const {
    geoedit
    //dispatch
    //redux
    
  } = props;

  const { paletteWidth, rangerHeight } = useSelector((state) => {
    const {
      ui:{
        paletteWidth,
        rangerHeight
      }={},
    }=state
    return { paletteWidth, rangerHeight }
  })

  const {
    getDataGeozoneIntersections,
    geoObjCriteria,
    rangeStartDate,
    rangeEndDate,
    geozoneArr,
    geozoneSettingsArr,
    getGeozoneIntersections,
    selectedGeoObjArray,
    dateRangeCriteria,
  } = useSelector(mapStateToProps);

  //const dispatch = useDispatch();

  const [intersectionsLoaded, setIntersectionsLoaded] = useState(false)
  const [selectedGeozone, setSelectedGeozone] = useState(null)

  /* геозоны !!! */
  useEffect(() => {
    const checkedGeozoneIndex = geozoneSettingsArr.findIndex(geozone => geozone.active === true)
    setSelectedGeozone(geozoneArr[checkedGeozoneIndex] || null)
  }, [geozoneArr, geozoneSettingsArr])


  useEffect(() => {
    if (geoObjCriteria === "2" && selectedGeozone?.id) {

      // let criteria={};
      const criteria = getCriteria(
        dateRangeCriteria,
        rangeStartDate,
        rangeEndDate,
    )

      const paramsToRequest = {
        criteria,
        geozoneId: Number(selectedGeozone?.id)
      }

      if (selectedGeoObjArray?.length) {
        paramsToRequest.trackerIds = selectedGeoObjArray
      }

      /* вызвать метод получения пересечений по выбранной геозоне !!! */
      getGeozoneIntersections(paramsToRequest)

    } else {
      console.log('disable request !!!')
      getGeozoneIntersections.abort && getGeozoneIntersections?.abort?.();
    }

    return ()=>{
      getGeozoneIntersections.abort && getGeozoneIntersections?.abort?.();
    }
  }, [geoObjCriteria, selectedGeozone?.id, rangeStartDate, rangeEndDate, selectedGeoObjArray?.length])
  /*---------------------------------------------------*/

  useEffect(() => {
    setIntersectionsLoaded(getDataGeozoneIntersections?.from === getDataGeozoneIntersections?.to)
  }, [getDataGeozoneIntersections?.from, getDataGeozoneIntersections?.to])

  const classes = useStyles({paletteWidth, rangerHeight});

  const st= {
    width: paletteWidth ? `calc(100vw - ${paletteWidth + (window.innerWidth > 768 ? 34 : 14)}px)` : '100%',
    right:'0px',
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
  }

  /* теперь этот компонент для вкладки геозоны должен уметь менять высоту карты
   и рендерить под ней таблицу пересечений !!! */

  return (
      <>
        <div
            style={st}
            className={classes.map}
            key='map'
        >
          <RadioGroup enableGeo/>
          <MapContentHolder
              paletteWidth={paletteWidth}
              rangerHeight={rangerHeight}
              geoedit={geoedit}
              isGeozonesIntersections={geoObjCriteria === "2" && getDataGeozoneIntersections?.data && selectedGeozone}
          />

            {!intersectionsLoaded && (
                <div className={classes.contentContainer}>
                  <SaveStatus errShowTime={1000} successShowTime={500} dataObj={getDataGeozoneIntersections} title="Загрузка таблицы пересечений"/>
                </div>
            )}

            {intersectionsLoaded && getDataGeozoneIntersections?.data && selectedGeozone && geoObjCriteria === "2" && (
                <div className={classes.geozoneIntersectionsTableWrapper}>
                  <GeozoneIntersections
                    dataForTable={getDataGeozoneIntersections}
                    selectedGeozone={selectedGeozone} />
                </div>
            )}

        </div>
      </>
  );
}

export default memo(MapLayout);
